import Echo from "laravel-echo";
import Socketio from "socket.io-client";


const socketEvents = {
  AI_CLINICIAN_CHAT_UPDATED:".aiClinicianChat.updated"
};

const connectToWebSocketsChannels = (authToken, userId) => {
  const socketHost = process.env.REACT_APP_SERVER_SOCKET_BASE_URL;

  const webSocketsConnection = new Echo({
    broadcaster: "socket.io",
    host: socketHost,
    client: Socketio,
    auth: {
      headers: {
        Authorization: "Bearer " + authToken
      }
    }
  });
  
  return webSocketsConnection;
};


const disconnectFromWebSocketsChannels = (connection, userId) => {
  if (!connection) return;

  connection.disconnect();
}


export { connectToWebSocketsChannels, disconnectFromWebSocketsChannels };
